import env from '@/config/env'
import { trackPlatformConnectStarted } from '@/lib/analytics/connectionTracking'

const SCOPE = [
  // Use your basic profile including your name, photo, headline, and public profile URL
  'r_basicprofile',
  // Retrieve the number of 1st-degree connections within your network
  // 'r_1st_connections_size',

  // Create, modify, and delete posts, comments, and reactions on your behalf
  'w_member_social',
  // Create, modify, and delete comments and reactions on posts on your behalf
  // 'w_member_social_feed',
  // Retrieve your posts and their reporting data
  // 'r_member_postAnalytics',
  // Retrieve your profile analytics, including number of profile viewers, followers, and search appearances
  // 'r_member_profileAnalytics',

  // Create, modify, and delete posts, comments, and reactions on your organization's behalf
  'w_organization_social',
  // Retrieve your organization's posts, comments, reactions, and other engagement data
  'r_organization_social',
  // Manage your organization's pages and retrieve reporting data
  'rw_organization_admin',
  // Create, modify, and delete comments and reactions on your organization's posts
  // 'w_organization_social_feed',
  // Retrieve comments, reactions, and other engagement data on your organization's posts
  // 'r_organization_social_feed',
  // Use your followers' data so your organization can mention them in posts
  // 'r_organization_followers',
] as const

export const AUTH_STATE_STORAGE_KEY = 'li_auth_state' as const
export type AuthState = { rnd: string; referrerPath: string }

export const startAuthProcess = (opts: Omit<AuthState, 'rnd'>) => {
  const redirectPath = '/auth/linkedIn'
  const state: AuthState = { ...opts, rnd: Math.random().toString().slice(3, 12) }

  localStorage.setItem(AUTH_STATE_STORAGE_KEY, JSON.stringify(state))

  const url = new URL('https://www.linkedin.com/oauth/v2/authorization')
  const params = new URLSearchParams({
    response_type: 'code',
    client_id: env.VITE_LINKEDIN_CLIENT_ID,
    redirect_uri: `${window.location.origin}${redirectPath}`,
    state: JSON.stringify(state),
    scope: SCOPE.join(' '),
  })

  trackPlatformConnectStarted('linkedin')
  window.location.href = `${url}?${params}`
}
